import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Danish",
  code: "da",
  messages: {
    alert: {
      close: "Luk"
    },
    authForm: {
      hidePassword: "Skjul adgangskode",
      showPassword: "Vis adgangskode",
      submit: "Forts\xE6t"
    },
    banner: {
      close: "Luk"
    },
    calendar: {
      nextMonth: "N\xE6ste m\xE5ned",
      nextYear: "N\xE6ste \xE5r",
      prevMonth: "Forrige m\xE5ned",
      prevYear: "Forrige \xE5r"
    },
    carousel: {
      dots: "V\xE6lg dias til visning",
      goto: "G\xE5 til slide {slide}",
      next: "N\xE6ste",
      prev: "Forrige"
    },
    chatPrompt: {
      placeholder: "Skriv din besked her..."
    },
    chatPromptSubmit: {
      label: "Send"
    },
    colorMode: {
      dark: "M\xF8rk",
      light: "Lys",
      switchToDark: "Skift til m\xF8rk tilstand",
      switchToLight: "Skift til lys tilstand",
      system: "System"
    },
    commandPalette: {
      back: "Tilbage",
      close: "Luk",
      noData: "Ingen data",
      noMatch: "Ingen matchende data",
      placeholder: "Skriv en kommando eller s\xF8g..."
    },
    contentSearch: {
      links: "Links",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "S\xF8g..."
    },
    contentToc: {
      title: "P\xE5 denne side"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "S\xF8g..."
    },
    dashboardSidebarCollapse: {
      collapse: "Sammenfold sidemenu",
      expand: "Udvid sidemenu"
    },
    dashboardSidebarToggle: {
      close: "Luk sidemenu",
      open: "\xC5bn sidemenu"
    },
    error: {
      clear: "Tilbage til forsiden"
    },
    fileUpload: {
      removeFile: "Fjern {filename}"
    },
    header: {
      close: "Luk menu",
      open: "\xC5bn menu"
    },
    inputMenu: {
      create: 'Opret "{label}"',
      noData: "Ingen data",
      noMatch: "Ingen matchende data"
    },
    inputNumber: {
      decrement: "Reducer",
      increment: "\xD8g"
    },
    modal: {
      close: "Luk"
    },
    pricingTable: {
      caption: "Prisplaneringssammenligning"
    },
    prose: {
      codeCollapse: {
        closeText: "Sammenfold",
        name: "kode",
        openText: "Udvid"
      },
      collapsible: {
        closeText: "Skjul",
        name: "egenskaber",
        openText: "Vis"
      },
      pre: {
        copy: "Kopi\xE9r kode til udklipsholder"
      }
    },
    selectMenu: {
      create: 'Opret "{label}"',
      noData: "Ingen data",
      noMatch: "Ingen matchende data",
      search: "S\xF8g..."
    },
    slideover: {
      close: "Luk"
    },
    table: {
      noData: "Ingen data"
    },
    toast: {
      close: "Luk"
    }
  }
});
